import { medicalActTemplateApi } from '@/core/api/medical-act-template'
import { medicalActRecordApi } from '@/core/api/medical-act-record'

// Template hooks
export const {
    useGetMedicalActTemplatesQuery,
    useGetMedicalActTemplateQuery,
    useCreateMedicalActTemplateMutation,
    useUpdateMedicalActTemplateMutation,
    useDeleteMedicalActTemplateMutation,
} = medicalActTemplateApi

// Record hooks
export const {
    useGetMedicalActRecordsQuery,
    useGetMedicalActRecordQuery,
    useGetMedicalActRecordsByConsultationQuery,
    useGetMedicalActRecordsByExpertiseQuery,
    useGetMedicalActRecordsByPatientQuery,
    useGetMedicalActStatisticsQuery,
    useGetMedicalActStatisticsByPerformerQuery,
    useGetMedicalActDetailedRecordsQuery,
    useCreateMedicalActRecordMutation,
    useDeleteMedicalActRecordMutation,
} = medicalActRecordApi

